import React from 'react';

import image from './kid@large.jpg';
import ib from './ib.svg';

import styles from './index.module.scss';

/* eslint-disable react/prop-types */
export default ({ locale }) => (
  <div className={styles.root}>
    <div className={styles.image} style={{ backgroundImage: `url(${image})` }} />
    <div className={`${styles.text} ${locale === 'zh' ? styles.zh : ''}`}>
      <img className={styles.ib} src={ib} alt="International Baccalaureate" />
      <h2 className={styles.title}>
        {locale === 'en' ? `First Authorized IBPYP School in Hong Kong` : `香港第一所獲授權推行IBPYP的學校`}
      </h2>
      {locale === 'en' ? (
        <p>
          In March 2004, Kingston became the first Authorized IBPYP school in Hong Kong. In recent years, the IBPYP
          programme has become the standard for International Schools in the region. What makes Kingston different in
          such a landscape is our vast experience and years of innovation within the IB framework. Kingston was
          instrumental in founding the Hong Kong IBPYP School Network and remains a leader in the distinct dual language
          English and Chinese approach to the IBPYP.
        </p>
      ) : (
        <p>
          京斯敦於二零零四年三月成為香港第一所獲授權推行國際文憑小學課程(IBPYP)的學校。現今，國際文憑小學課程已經成為區域性國際學校的標準課程。京斯敦的突出之處在於其多年的IBPYP課程經驗，以及在該課程框架下的創新教學。京斯敦在香港IBPYP學校網絡推行中英雙語教學中具領導地位。
        </p>
      )}
    </div>
  </div>
);
